<div class="mb-20">
  {{ 'dashboard_report.position_info' | translate }}
</div>
<gridster [options]="options">
  <gridster-item *ngFor="let w of dashboard"
                 (itemChange)="onChange($event)"
                 (itemResize)="onResize($event)"
                 [item]="w"
                 [ngClass]="{ 'current-widget': w === widget }">
    <ng-container *ngIf="w === widget; else elseblock">
      {{ form.controls.title.value || 'Widget' }}
    </ng-container>
    <ng-template #elseblock>
      {{ w.config.title }}
    </ng-template>
  </gridster-item>
</gridster>
